<template>
  <div class="header-wrapper" :class="{ 'not-fixed': fixedHeader }">
    <div class="header">
      <div class="header__left">
        <router-link tag="a" to="/" class="header__logo">
          <vimg src="static/images/logo.svg" />

          <span v-if="isAdmin || (adminToken && adminToken.token)" class="header__admin-label" @click="goAdmin">
            Admin
          </span>
        </router-link>

        <transition name="slide-fade">
          <navigation class="header__navigation" />
        </transition>

        <transition name="slide-fade">
          <search-form v-show="isSearchShow" class="header__search" />
        </transition>

        <!-- <div class="header__notify"><i class="icon-bell"></i></div> -->

        <div
          v-if="$route.name !== 'vacancies'"
          class="header__action-btn"
          @click="$router.push({ name: 'invites-creation' })"
        >
          {{ $tr('actions.invite') }}
        </div>

        <div
          v-if="$route.name === 'vacancies'"
          v-tooltip.bottom="createVacancyTooltipOptions"
          class="header__action-btn"
          :class="{ loading: isVacancyLoading }"
          @click="isVacancyCreationDisabled ? SET_IS_EXPIRED_MODAL_SHOW(true) : SET_IS_CREATING_MODAL_SHOW(true)"
        >
          <i v-if="isVacancyCreationDisabled" class="icon icon-locked"></i>
          {{ $tr('actions.create') }}

          <div class="header__action-btn-loading-wrapper">
            <div class="header__action-btn-loading"></div>
          </div>
        </div>

        <transition name="slide-fade">
          <div
            v-show="!isSearchShow && !isMobileMenuShow"
            class="header__search-icon"
            :class="{ active: isSearchShow }"
            @click="toggleSearch"
          >
            <i class="icon icon-loupe"></i>
          </div>
        </transition>
      </div>

      <profile-info class="header__profile" />

      <transition name="slide-fade">
        <navigation-mobile v-if="isMobileMenuShow" />
      </transition>

      <div class="ham" :class="{ open: isMobileMenuShow || isSearchShow }" @click="toggleHam">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';
import debounce from 'lodash/debounce';
import Security from '@/_helpers/security';
import SearchForm from '@/components/header/SearchForm';
import Navigation from '@/components/header/Navigation';
import NavigationMobile from '@/components/header/NavigationMobile';
import ProfileInfo from '@/components/header/ProfileInfo';

export default {
  name: 'VcvHeader',

  components: {
    SearchForm,
    Navigation,
    NavigationMobile,
    ProfileInfo
  },

  props: {
    displayNavigation: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isSecondNavVisible: true,
      fetch_rates_interval: null, // TODO: удалить и запрашивать периодически в другом месте, а в будущем вообще перейти на sockets
      adminToken: null,
      isMobileMenuShow: false,
      isSearchShow: false
    };
  },

  computed: {
    ...mapState('vacancy', { isVacancyLoading: 'loading' }),

    ...mapState('company_new', ['rates']),

    ...mapGetters('user', ['isAdmin', 'isCompanyAdmin', 'isCompanyUser']),

    isUnlimited() {
      if (!this.rates) {
        return false;
      }

      return this.rates.vacancy_limit === null && this.rates.response_limit === null && this.rates.paid_to === null;
    },

    isVacancyCreationDisabled() {
      if (!this.rates) {
        return 0;
      }

      return this.rates.vacancy_balance !== null && this.rates.vacancy_balance <= 0;
    },

    headerStyle() {
      return this.$route.meta ? this.$route.meta.headerOptions : null;
    },

    fixedHeader() {
      return this.headerStyle ? this.headerStyle.fixed === false : null;
    },

    createVacancyTooltipOptions() {
      if (!this.isVacancyCreationDisabled) {
        return {};
      }

      return {
        content: this.$tr('rates.vacanciesExpired'),
        placement: 'top-center',
        classes: 'tight'
      };
    }

    // is_grid() {
    //   return this.$route.name === 'vacancy_application' || this.$route.name === 'vacancy_tests';
    // }
  },

  watch: {
    isUnlimited: {
      immediate: true,
      handler() {
        if (this.isUnlimited && this.fetch_rates_interval) {
          clearInterval(this.fetch_rates_interval);
        }
      }
    }
  },

  async created() {
    this.windowWidthHandler();
    window.addEventListener('resize', this.windowWidthHandler);

    const admin_token = Security.admin_token;

    if (admin_token) {
      this.adminToken = admin_token;
    }
  },

  destroyed() {
    window.removeEventListener('resize', this.windowWidthHandler);

    clearInterval(this.fetch_rates_interval);
  },

  methods: {
    ...mapMutations('vacancies', ['SET_IS_CREATING_MODAL_SHOW', 'SET_IS_EXPIRED_MODAL_SHOW']),

    windowWidthHandler: debounce(function () {
      if (window.innerWidth > 992) {
        this.isSearchShow = true;
        this.isMobileMenuShow = false;
      } else {
        this.isSearchShow = false;
        this.isMobileMenuShow = false;
      }
    }, 100),

    toggleHam() {
      if (this.isMobileMenuShow || this.isSearchShow) {
        this.isMobileMenuShow = false;
        this.isSearchShow = false;
      } else {
        this.isMobileMenuShow = true;
        this.isSearchShow = false;
      }
    },

    toggleSearch() {
      this.isMobileMenuShow = false;
      this.isSearchShow = true;
    },

    isInViewport(element) {
      const rect = element.getBoundingClientRect();
      const html = document.documentElement;
      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || html.clientHeight) &&
        rect.right <= (window.innerWidth || html.clientWidth)
      );
    },

    goAdmin() {
      if (this.adminToken && (this.isCompanyAdmin || this.isCompanyUser)) {
        Security.access_token = this.adminToken;
      }

      window.location = '/admin';
    }
  }
};
</script>

<style lang="scss">
@import '@/styles/colors.scss';
@import '@/styles/queries.scss';
@import '@/styles/fonts.scss';

.header-wrapper {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 9997;
  width: 100%;
  background: #fff;
  border-bottom: 1px solid $input-light-border-color;

  @media (max-width: 960px) {
    position: relative;
  }

  &.not-fixed {
    position: relative;
  }
}

.header {
  width: 100%;
  height: 64px;
  margin: 0 auto;
  display: flex;
  padding-left: 20px;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;

  @media screen and (max-width: 1100px) {
    font-size: 0.9em !important;
  }

  @media screen and (max-width: 992px) {
    padding: 0 20px;
  }

  &__left {
    display: flex;
    align-items: stretch;
    flex: 1;

    @media screen and (max-width: 992px) {
      justify-content: space-between;
    }
  }

  &__logo {
    margin: auto 0;
    height: 30px;
    position: relative;

    @media screen and (max-width: 1100px) {
      height: 25px;
    }

    @media screen and (max-width: 992px) {
      height: 30px;
    }

    img {
      width: auto;
      height: 100%;
    }
  }

  &__search-icon {
    display: none;
    font-size: 1.45em;
    color: $main-dark;
    transition: color 0.3s;

    @media screen and (max-width: 992px) {
      display: flex;
      margin-right: 20px;
      align-items: center;
      cursor: pointer;
    }

    &:hover {
      color: $green-hover;
      transition: color 0.3s;
    }

    &.active {
      color: $green;
      transition: color 0.3s;
    }
  }

  &__search {
    @media screen and (max-width: 992px) {
      position: absolute !important;
      left: 0;
      top: 65px;
      width: 100%;
      border-bottom: 1px solid $grey-light;
      box-shadow: $box-shadow;
    }
  }

  &__notify {
    background: $blue;
    flex: 0 0 64px;
    width: 64px;
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    position: relative;
    transition: background 0.3s;

    &:before {
      content: '';
      width: 100%;
      height: 1px;
      background: $blue;
      position: absolute;
      left: 0;
      bottom: -1px;
      transition: background 0.3s;
    }

    &:hover {
      background: $blue-dark;
      transition: background 0.3s;

      &:before {
        background: $blue-dark;
        transition: background 0.3s;
      }
    }

    &:focus {
      background: $blue-dark;
      transition: background 0.3s;
    }

    @media screen and (max-width: 992px) {
      display: none;
    }
  }

  &__action-btn {
    @include mixin-text-header;
    background: $green;
    padding: 0 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    cursor: pointer;
    white-space: nowrap;
    position: relative;
    transition: background 0.3s;

    &:before {
      content: '';
      width: 100%;
      height: 1px;
      background: $green;
      position: absolute;
      left: 0;
      bottom: -1px;
      transition: background 0.3s;
    }

    &:hover {
      background: $green-hover;
      transition: background 0.3s;

      &:before {
        background: $green-hover;
        transition: background 0.3s;
      }
    }

    &:focus {
      background: $green-active;
      transition: background 0.3s;
    }

    @media screen and (max-width: 1200px) {
      display: none;
    }

    &.disabled {
      opacity: 0.65;
      pointer-events: none;
    }

    i {
      font-size: 26px;
      margin-right: 10px;
    }

    &.loading {
      .header__action-btn-loading-wrapper {
        opacity: 1;
        transition: opacity 0.2s;
      }
    }
  }

  &__action-btn-loading-wrapper {
    width: 100%;
    height: 4px;
    position: absolute;
    bottom: -1px;
    left: 0;
    overflow: hidden;
    pointer-events: none;
    opacity: 0;
    transition: opacity 0.2s;
  }

  &__action-btn-loading {
    width: 200%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    animation-name: progressbar;
    animation-duration: 1s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
    background: repeating-linear-gradient(
      45deg,
      $green-active,
      $green-active 10px,
      $green-hover 10px,
      $green-hover 20px
    );
  }

  @keyframes progressbar {
    from {
      transform: translateX(-29px);
    }

    to {
      transform: translateX(0);
    }
  }

  &__admin-label {
    font-size: 10px;
    padding: 3px 6px;
    background: $red;
    color: #fff;
    border-radius: 3px;
    position: absolute;
    right: -20px;
    bottom: -10px;
    cursor: pointer;
    transition: background 0.3s;

    &:hover {
      background: $red-light;
      transition: background 0.3s;
    }
  }

  &__navigation {
    @media screen and (max-width: 992px) {
      display: none !important;
    }
  }

  &__profile {
    border-left: none;

    @media screen and (max-width: 1200px) {
      border-left: 1px solid $grey-light;
    }

    @media screen and (max-width: 992px) {
      display: none;
    }
  }

  .slide-fade-enter,
  .slide-fade-leave-to {
    transition: all 0.2s ease;
    transform: translateY(5px);
    opacity: 0;
  }
}

// hamburger menu
.ham {
  width: 32px;
  height: 16px;
  position: relative;
  transform: rotate(0deg);
  transition: 0.3s ease-in-out;
  display: flex;
  justify-content: flex-end;
  cursor: pointer;

  @media screen and (min-width: 993px) {
    display: none;
  }
}

.ham span {
  display: block;
  position: absolute;
  height: 2px;
  width: 100%;
  background: $main-dark;
  border-radius: 1px;
  opacity: 1;
  left: 0;
  transform: rotate(0deg);
  transition: 0.25s ease-in-out;
}

.ham span:nth-child(1) {
  top: 0px;
}

.ham span:nth-child(2),
.ham span:nth-child(3) {
  top: 7px;
}

.ham span:nth-child(4) {
  width: 70%;
  top: 14px;
  right: 0;
  left: auto;
}

.ham.open span:nth-child(1) {
  top: 7px;
  width: 0%;
  left: 50%;
}

.ham.open span:nth-child(2) {
  transform: rotate(45deg);
}

.ham.open span:nth-child(3) {
  transform: rotate(-45deg);
}

.ham.open span:nth-child(4) {
  top: 7px;
  width: 0%;
  left: 50%;
}
</style>
